import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import { themes } from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { Loader } from "components/Loader";
import { tableRowSx } from "services/constants";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const overTimeKeyPair = [
  {
    key: "user_name",
    name: "Employee name",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    key: "check_in_datetime",
    name: "Check-in",
  },
  {
    key: "check_out_datetime",
    name: "Check-out",
  },
  {
    key: "approvedby",
    name: "Approver",
  },
  {
    key: "approvedat",
    name: "Approved At",
  },
];

export const History = () => {
  const { domain, token, userDetails, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );
  const [overTimeDetails, setOverTimeDetails] = useState([1]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [listViewPage, setListViewPage] = useState(0);
  const [loader, setLoader] = useState(true);
  const [historyData, setHistoryData] = useState([]);

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };
  const handleStartDate = async (startDate, endDate) => {
    let searchStartDate = startDate.split("/").reverse().join("-");
    let searchEndDate = endDate.split("/").reverse().join("-");
    setLoader(true);
    try {
      const response = await fetch(
        `${domain}week-off-approvals/?selected_user_id=${userDetails.id}&status=Approved&start_date=${searchStartDate}&end_date=${searchEndDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        const combinedData = res.map((item) => ({
          ...item,
          overtime_period: `${item.check_in_datetime || "N/A"} to ${
            item.check_out_datetime || "N/A"
          }`,
        }));
        setOverTimeDetails(combinedData);
        setHistoryData(combinedData);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
      setLoader(false);
    } catch (error) {
      showToast("error", error.message);
    }
  };

  useEffect(() => {
    const searchFields = [
      "user_name",
      "date",
      "shift_name",
      "check_in_datetime",
      "check_out_datetime",
      "approvedby",
      "approvedat",
    ];
    const filteredResults = historyData.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setOverTimeDetails(filteredResults);
    setListViewPage(0);
  }, [historyData, globalSearchValue]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.Grid item xs={9.25}></Mui.Grid>
        <Mui.Grid item xs={2.6} sx={{ paddingTop: 1, marginTop: -7 }}>
          <BSDateRangePicker
            handleStartDate={handleStartDate}
            showToday={true}
            triggerDate={true}
          />
        </Mui.Grid>
      </Mui.Grid>

      {loader === true ? (
        <Loader info="Loading..." />
      ) : (
        <>
          <Mui.Grid container>
            <Mui.TableContainer sx={{ mt: 2, width: "100%", ml: 2, mr: 2 }}>
              <Mui.Table className="border" sx={tableRowSx}>
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                  }}
                >
                  <Mui.TableRow>
                    {overTimeKeyPair.map((header) => (
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        {header.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {overTimeDetails?.length === 0 ? (
                    <InfoMessage dataLength={historyData} />
                  ) : (
                    overTimeDetails
                      ?.slice(
                        listViewPage * rowsPerPage,
                        listViewPage * rowsPerPage + rowsPerPage
                      )
                      .map((department) => (
                        <Mui.TableRow sx={tableRowSx}>
                          {overTimeKeyPair.map((header) => (
                            <Mui.TableCell sx={{ color: themes.headLine }}>
                              {department[header.key]
                                ? department[header.key]
                                : "N/A"}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          {overTimeDetails?.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={overTimeDetails?.length}
              rowsPerPage={rowsPerPage}
              page={listViewPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};
